// Shared event names connecting Stripe checkout and submit buttons.
// State notifications prompt a fresh readiness query.
export const CHECKOUT_STATE_EVENT = 'payments:checkout:state'
export const CHECKOUT_STATE_REQUEST_EVENT = 'payments:checkout:state-request'
